import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncentiveDashboardComponent } from './pages/incentive-dashboard/incentive-dashboard.component';
import { PaymentsPageComponent } from './pages/payments-page/payments-page.component';
import { DistributionPageComponent } from './pages/distribution-page/distribution-page.component';
import { CalculatePageComponent } from './pages/calculate-page/calculate-page.component';
import { IncentiveRoutingModule } from './incentive-routing.module';
import { MaterialModule } from '@reenstudio/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IncentivePerformanceComponent } from './components/incentive-cards/incenvitve-performance/incentive-performance.component';
import { AppYearlyPerformanceComponent } from './components/incentive-cards/yearly-performance/yearly-performance.component';
import { AppMainGseCard } from './components/incentive-cards/main-gse-card/main-gse-card.component';
import { AppMainDistributionCard } from './components/distribution-cards/main-distribution-card/main-distribution-card.component';
import { DistributionPerformanceComponent } from './components/distribution-cards/distribution-performance/distribution-performance.component';
import { YearlyDistributionPerformanceComponent } from './components/distribution-cards/yearly-distribution-performance/yearly-distribution-performance.component';
import { MainCerCardsComponent } from './components/cer-cards/main-cards/main-cards.component';
import { StatusLabelComponent } from '@reenstudio/app/shared/components/status-label/status-label.component';

@NgModule({
  declarations: [
    IncentiveDashboardComponent,
    PaymentsPageComponent,
    DistributionPageComponent,
    CalculatePageComponent,
  ],
  imports: [
    CommonModule,
    IncentiveRoutingModule,
    MaterialModule,
    TablerIconsModule,
    AppMainGseCard,
    IncentivePerformanceComponent,
    AppYearlyPerformanceComponent,
    AppMainDistributionCard,
    DistributionPerformanceComponent,
    YearlyDistributionPerformanceComponent,
    MainCerCardsComponent,
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    StatusLabelComponent,
  ],
})
export class IncentiveModule {}
